import { useTranslation } from '../i18n';
import "./InvitationText.css";
import "./LanguageTransition.css";

function InvitationText() {
  const { t, language, isTransitioning } = useTranslation();
  
  // Check if we're on the two-day page by looking at the URL path
  const isTwoDayPage = window.location.pathname.includes('2day');
  
  return (
    <div className="invitation-text">
      <div className="line">{t('invitationText.zuUnserer')}</div>
      <div className={language === 'fr' ? 'line' : 'bold'}>
        {t(isTwoDayPage ? 'invitationText.hochzeit' : 'invitationText.hochzeitsparty')}
      </div>
      <div className="line">{t('invitationText.ladenWir')}</div>
      <div className={language === 'fr' ? 'bold' : 'line'}>
        {t(isTwoDayPage ? 'invitationText.hochzeitBold' : 'invitationText.herzlichEinBold')}
      </div>
    </div>
  );
}

export default InvitationText;
